<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-12 15:51:08
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-15 17:49:24
 * @FilePath: \mrc-base-server-view\src\views\data-access-strategy\modules\baseInfo.vue
-->
<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <!-- :background-color="disabled ? '' : '#f5f5f5'"  
                :readonly="true"-->
            <!-- :error-messsage="
                $errors('params', 'org_level_uuid', requiredRule)
              " -->
            <mrc_ess_autoComplete :label="$t('label_Use_the_unit')"
                                  :readonly="disabled"
                                  :disabled="true"
                                  orgView
                                  v-model="params.org_level_uuid"
                                  :prompt_name="org_uuid">
            </mrc_ess_autoComplete>
          </v-col>
          <v-col class="d-flex"
                 cols="12"
                 sm="6">
            <!-- @blur="$v.params.effective_start_date.$touch()" -->
            <mrc_ess_datePicker :errMsg="
                $errors(
                  'params',
                  'effective_start_date',
                  requiredRule.concat([
                    {
                      rule: 'beforeData',
                      msg: $t('verify_The_date_was_filled_in_incorrectly'),
                    },
                  ])
                )
              "
                                :disabled="disabled"
                                :placeholder="$t('label_effective_start_date')"
                                :label="$t('label_effective_start_date') + '*'"
                                v-model="params.effective_start_date"></mrc_ess_datePicker>
          </v-col>
          <v-col class="d-flex"
                 cols="12"
                 sm="6">
            <!-- @blur="$v.params.effective_end_date.$touch()" -->
            <mrc_ess_datePicker :errMsg="
                $errors('params', 'effective_end_date', [
                  {
                    rule: 'afterData',
                    msg: $t('verify_The_date_was_filled_in_incorrectly'),
                  },
                ])
              "
                                :disabled="disabled"
                                :placeholder="$t('label_effective_end_date')"
                                :label="$t('label_effective_end_date')"
                                v-model="params.effective_end_date"></mrc_ess_datePicker>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn :successText="
          $store.state.uuid ? $t('label_submit') : $t('label_The_next_step')
        "
                         @success="success"
                         v-if="!disabled"
                         @cancel="cancel"></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import {
  listData,
  getData,
  updateData,
  addData,
  delData,
  updatebasis,
} from '@/service/api/data-access-strategy'
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      skeletonloading: true,
      params: {
        org_level_uuid: '',
        effective_start_date: '',
        effective_end_date: '',
      },
      list: [],
    }
  },

  computed: {
    org_uuid () {
      return {
        prompt_name: 'manager-sub-company',
        org_level_uuid: this.$store.state.currentCompany,
      }
      // return { prompt_name: 'org_levels_manager_filter_company', user_uuid: this.$store.state.userData.uuid }
    },
  },
  created () { },
  watch: {},
  async mounted () {
    this.national('mrbase_sys_flow_proxy_approval')
    if (this.$store.state.uuid) {
      await this.getList()
    } else {
      this.params.org_level_uuid = this.$store.state.currentCompany
    }
  },
  methods: {
    async getList () {
      if (this.$store.state.uuid) {
        this.skeletonloading = true
        const res = await getData({
          org_level_uuid: this.$store.state.uuid,
          // date: 'mrbase_sys_data_strategy_same_post_grade',
        })
        if (res.code == 200) {
          // this.list = res.mrbase_sys_data_strategy_same_post_grade ? res.mrbase_sys_data_strategy_same_post_grade : []
          this.params = res.data
        } else {
          this.$Message({ text: res.msg, color: 'rgba(0, 0, 0, 0.38)' })
        }
        this.skeletonloading = false
      } else {
      }
    },
    async success () {
      this.$v.params.$touch()
      if (this.$v.params.$error) return
      if (this.$store.state.uuid) {
        //修改
        const res = await updatebasis({
          ...this.params,
        })
        if (res.code == 200) {
          this.$Message({ text: this.$t('message_The_operation_was_successful') })
          await this.getList()
          this.$emit('updateSuccess')
        }
      } else {
        //新增
        this.$emit('success', this.params)
      }
    },
    async cancel () {
      if (this.$store.state.uuid) {
        await this.getList()
        this.$emit('updateSuccess')
        // this.$myConfirm({
        //   content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
        // })
        //   .then((res) => {
        //     this.$router.push({ name: 'data-access-strategy' })
        //   })
        //   .catch((err) => { })
      }
      else {
        this.$emit('cancel')
      }
    },
  },
  validations: {
    params: {
      org_level_uuid: {
        // required,
      },
      effective_start_date: {
        required,
        beforeData (value) {
          if (!this.params.effective_end_date) return true
          const prevData = new Date(value).valueOf()
          const nextData = new Date(this.params.effective_end_date).valueOf()
          return prevData < nextData
        },
      },
      effective_end_date: {
        // required,
        afterData (value) {
          if (!this.params.effective_start_date) return true
          if (!this.params.effective_end_date) return true
          const nextData = new Date(value).valueOf()
          const prevData = new Date(this.params.effective_start_date).valueOf()
          return prevData < nextData
        },
      },
    },
  },
}
</script>

<style scoped></style>
